import { UrlProvider } from "../../Infrastructure/UrlProvider";

export class LookupStore { 
    private _controller = new AbortController();

    private static _instance = new LookupStore();
    static get instance() { return this._instance; }

    public async lookup(query: string): Promise<Car[]> {
        this._controller?.abort();
        this._controller = new AbortController();

        if (!query)
            return [];

        

        const response = await fetch(`${UrlProvider.fleetRoot}/api/lookup?query=${query}`, {
            headers: {
                'if-none-match': 'W/"1'
            },
            signal: this._controller.signal
        });
        const json = await response.json();
        return json;
    }
}

export interface Car { 
    carId: number;
    carEditionId: number;
    brand: string;
    series: string;
    model: string;
    yearBegin: number;
    yearEnd: number;
    originalTyreSize: string;
}